import ListAltOutlinedIcon from "@mui/icons-material/ListAltOutlined";
import LocalGroceryStoreOutlinedIcon from "@mui/icons-material/LocalGroceryStoreOutlined";
import RestoreOutlinedIcon from "@mui/icons-material/RestoreOutlined";
import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useMutation, useQueryClient } from "react-query";
import { useHistory } from "react-router-dom";
import ShowErrorsModal from "../../components/modals/ShowErrorModal";
import TabPanelCmp from "../../components/tabPanel/tabPanelCmp";
import { WORK_FLOW_TYPE } from "../../config/cacheKey";
import {
  ErrorsTab,
  GetCartableActionsResponse,
} from "../../models/cartable.model";
import {
  CartableHistory,
  GetSaleInformationResponse,
} from "../../models/settlement.model";
import { GetCartableActions } from "../../services/cartable.service";
import { getSaleInformation } from "../../services/settlement.service";
import ActionTabs from "../detail/actionCopmonets.tsx/actionTab/actionTabs";
import TabsSkeleton from "../permission/components/TabsSkeleton";
import FactorItemsTab from "./components/FactorItemsTab";
import SaleDetailActionsHeader from "./components/SaleDetailActionsHeader";
import SaleDetailTab from "./components/SaleDetailTab";
import SaleHeader from "./components/SaleHeader";
import SaleHeaderSkeleton from "./components/SaleHeaderSkeleton";
import WorkflowTabTable from "./components/WorkflowTabTable";

const StoreRequestDetail = () => {
  const [activeTab, setActiveTab] = useState<any>();
  const [saleInfo, setSaleInfo] = useState<GetSaleInformationResponse>();
  const history = useHistory<{
    settlementData?: {
      saleKey: string;
      key?: string;
      branchId?: number;
      customerPersonId?: number;
    };
  }>();

  const settlementData =
    history?.location?.state?.settlementData !== undefined
      ? history?.location?.state?.settlementData
      : JSON.parse(
          window.localStorage.getItem("SETTLEMENT_REQUEST_DATA") || "{}"
        );
  const referenceKey = settlementData.saleKey;

  const queryClient = useQueryClient();
  const [dataGetCartableActions, setDataGetCartableActions] = useState<
    GetCartableActionsResponse[]
  >();
  const [flagActionTabs, setFlagActionTab] = useState(false);
  let getCartableAction: string;
  getCartableAction = queryClient.getQueryData(WORK_FLOW_TYPE)!;
  if (getCartableAction === null || getCartableAction === undefined) {
    getCartableAction = localStorage.getItem("setActivePage")!;
  }
  const [actionTabsData, setActionTabData] = useState();
  const [showActionBtns, setShowActionBtns] = useState(false);
  const [reload, setReload] = useState<any>();
  const [isActionModalBtnDisable, setActionModalBtnDisable] = useState(false);
  const [workflowStepType, setWorkflowStepType] = useState("");
  const [error, setError] = useState([] as ErrorsTab[]);
  const [openModal, setOpenModal] = useState(false);
  let errorTempArray = [] as ErrorsTab[];

  // service calls
  const { mutate: getSaleInformationMutate, isLoading } = useMutation(
    getSaleInformation,
    {
      onSuccess: (data: GetSaleInformationResponse) => {
        if (data) {
          setSaleInfo(data);
        }
      },
      onError: () => {},
    }
  );

  useEffect(() => {
    getSaleInformationMutate({
      saleKey: referenceKey,
    });
    getCartableActionsMutation({
      referenceKey: referenceKey,
      workflowType: "SaleSettlement",
    });
  }, [reload]);

  const { mutateAsync: getCartableActionsMutation } = useMutation(
    GetCartableActions,
    {
      onSuccess: (data: GetCartableActionsResponse[]) => {
        if (data) {
          setDataGetCartableActions(data);
          setShowActionBtns(true);
        }
      },
    }
  );

  // handlers
  const handleMoreClick = (cartable: CartableHistory) => {
    if (cartable?.userData?.length > 0) {
      cartable?.userData?.map((item: any) => {
        let errortemp = { errorsHeader: item.key, errorMessages: item.value };
        errorTempArray.push(errortemp);
        setError(errorTempArray);
        setWorkflowStepType(cartable?.workflowStepType);
      });
      setOpenModal(true);
    }
  };

  const tabs = [
    saleInfo?.saleDetail && {
      id: 0,
      key: "saleDetail",
      title: "جزییات فروش",
      icon: (
        <LocalGroceryStoreOutlinedIcon sx={{ marginBottom: "0 !important" }} />
      ),
      child: !isLoading ? (
        <>
          <SaleDetailTab saleData={saleInfo?.saleDetail!} />
        </>
      ) : (
        <TabsSkeleton />
      ),
    },
    (saleInfo?.saleItems.items?.length !== 0 ||
      saleInfo?.saleItems?.invoiceFiles) && {
      id: 1,
      key: "factorItems",
      title: "اقلام فاکتور",
      icon: <ListAltOutlinedIcon sx={{ marginBottom: "0 !important" }} />,
      child: (
        <>
          <FactorItemsTab saleData={saleInfo?.saleItems!} />
        </>
      ),
    },
    saleInfo?.cartableHistory?.length! > 0 && {
      id: 2,
      key: "workflow",
      title: "گردش کار",
      icon: <RestoreOutlinedIcon sx={{ marginBottom: "0 !important" }} />,
      child: (
        <WorkflowTabTable
          cartableHistory={saleInfo?.cartableHistory!}
          handleMoreClick={handleMoreClick}
        />
      ),
    },
  ].filter(Boolean);

  return (
    <Grid
      container
      flexDirection={"column"}
      sx={{ flexWrap: "unset", paddingTop: "10px" }}
    >
      {dataGetCartableActions?.length! > 0 && (
        <SaleDetailActionsHeader
          dataGetCartableActions={dataGetCartableActions}
          isActionModalBtnDisable={isActionModalBtnDisable}
          flagActionTabs={flagActionTabs}
          setReload={setReload}
          getCartableAction={getCartableAction}
          setDataGetCoreInformation={setSaleInfo}
          referenceKey={referenceKey}
          setActionModalBtnDisable={setActionModalBtnDisable}
          setShowActionBtns={setShowActionBtns}
          setDataGetCartableActions={setDataGetCartableActions}
          setActionTabData={setActionTabData}
          setFlagActionTab={setFlagActionTab}
          showActionBtns={showActionBtns}
          showInstallmentComponent={false}
        />
      )}

      {!isLoading ? (
        <Grid
          item
          sx={{ marginTop: "10px", marginBottom: "20px", width: "100%" }}
        >
          <SaleHeader headerData={saleInfo?.header!} />
        </Grid>
      ) : (
        <SaleHeaderSkeleton />
      )}
      {flagActionTabs && (
        <ActionTabs
          setFlagActionTab={setFlagActionTab}
          actionTabsData={actionTabsData}
          referenceKey={referenceKey}
          setDataGetCoreInformation={setSaleInfo}
          setDataGetCartableActions={setDataGetCartableActions}
          getCartableAction={getCartableAction}
          setReload={setReload}
        />
      )}
      <Grid item sx={{ width: "100%" }}>
        <TabPanelCmp
          tab={tabs}
          colorTab={"#01af43"}
          setActiveTab={setActiveTab}
        />
      </Grid>
      <ShowErrorsModal
        openModal={openModal}
        setOpenModal={setOpenModal}
        validationMessages={error}
        workflowStepType={workflowStepType}
      />
    </Grid>
  );
};

export default StoreRequestDetail;
